/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_Site_ShouldersInputs */

const en_us2_body_measures_site_shoulders = /** @type {(inputs: Body_Measures_Site_ShouldersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoulders`)
};

const pt_br2_body_measures_site_shoulders = /** @type {(inputs: Body_Measures_Site_ShouldersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ombros`)
};

const es_419_body_measures_site_shoulders = /** @type {(inputs: Body_Measures_Site_ShouldersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hombros`)
};

const pt_pt2_body_measures_site_shoulders = /** @type {(inputs: Body_Measures_Site_ShouldersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ombros`)
};

const fr_fr2_body_measures_site_shoulders = /** @type {(inputs: Body_Measures_Site_ShouldersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Épaules`)
};

const de_de2_body_measures_site_shoulders = /** @type {(inputs: Body_Measures_Site_ShouldersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schultern`)
};

const it_it2_body_measures_site_shoulders = /** @type {(inputs: Body_Measures_Site_ShouldersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spalle`)
};

/**
* | output |
* | --- |
* | "Shoulders" |
*
* @param {Body_Measures_Site_ShouldersInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_site_shoulders = /** @type {((inputs?: Body_Measures_Site_ShouldersInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_Site_ShouldersInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_site_shoulders(inputs)
	if (locale === "es-419") return es_419_body_measures_site_shoulders(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_site_shoulders(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_site_shoulders(inputs)
	if (locale === "de-DE") return de_de2_body_measures_site_shoulders(inputs)
	if (locale === "it-IT") return it_it2_body_measures_site_shoulders(inputs)
	return en_us2_body_measures_site_shoulders(inputs)
});
export { body_measures_site_shoulders as "body-measures.site_shoulders" }